import React, { useEffect, Suspense, lazy } from 'react';
import { OfferBar } from './components/OfferBar';
import { ProgressBar } from './components/ProgressBar';
import { Footer } from './components/Footer';
import { SocialProofBar } from './components/SocialProofBar';
import { PurchasePopup } from './components/PurchasePopup';
import { initMetaPixel } from './hooks/useMetaPixel';
const HeroSection = lazy(() => import('./components/HeroSection'));
const PainSection = lazy(() => import('./components/PainSection'));
const OldSolutionsSection = lazy(() => import('./components/OldSolutionsSection'));
const MechanismSection = lazy(() => import('./components/MechanismSection'));
const IncludesSection = lazy(() => import('./components/IncludesSection'));
const ResultSection = lazy(() => import('./components/ResultSection'));
const ForWhomSection = lazy(() => import('./components/ForWhomSection'));
const ObjectionsSection = lazy(() => import('./components/ObjectionsSection'));
const FinalCTA = lazy(() => import('./components/FinalCTA'));
const PricingSection = lazy(() => import('./components/PricingSection'));
const FacebookCommentsSection = lazy(() => import('./components/FacebookCommentsSection'));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection'));
const SectionLoader = () => <div className="min-h-[40vh] flex items-center justify-center" data-id="element-0">
    <div className="relative" data-id="element-1">
      <div className="w-3 h-3 bg-brand-purple/60 rounded-full animate-ping" data-id="element-2" />
      <div className="absolute inset-0 w-3 h-3 bg-brand-purple rounded-full" data-id="element-3" />
    </div>
  </div>;
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <>
      <OfferBar data-id="element-4" />
      <ProgressBar data-id="element-5" />

      {/* Ambient floating orbs */}
      <div className="ambient-orb ambient-orb-1" data-id="element-6" />
      <div className="ambient-orb ambient-orb-2" data-id="element-7" />
      <div className="ambient-orb ambient-orb-3" data-id="element-8" />

      <main className="relative z-10 min-h-screen text-slate-700 selection:bg-brand-purple/30 selection:text-slate-900 pt-12 font-sans" data-id="element-9">
        <Suspense fallback={<SectionLoader data-id="element-11" />} data-id="element-10">
          <HeroSection data-id="element-12" />
          <PainSection data-id="element-13" />
          <OldSolutionsSection data-id="element-14" />
          <ForWhomSection data-id="element-15" />
          <SocialProofBar data-id="element-16" />
          <MechanismSection data-id="element-17" />
          <IncludesSection data-id="element-18" />
          <TestimonialsSection data-id="element-19" />
          <FacebookCommentsSection data-id="element-20" />
          <PricingSection data-id="element-21" />
          <ResultSection data-id="element-22" />
          <FinalCTA data-id="element-23" />
          <ObjectionsSection data-id="element-24" />
        </Suspense>
        <Footer data-id="element-25" />
        <PurchasePopup data-id="element-26" />
      </main>
    </>;
}